import React from 'react'
import { connect } from 'react-redux'

import Consultant from 'components/Consultant'
import WelcomeMessage from 'components/WelcomeMessage'

const Home = ({ id, welcomeMessage }) => (
  <React.Fragment>
    <Consultant consultantId={id} />
    {welcomeMessage && <WelcomeMessage />}
  </React.Fragment>
)

const mapStateToProps = state => ({
  id: state.auth.user.id,
  welcomeMessage: state.auth.welcomeMessage,
})

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/pages/Home.js